import axios from 'axios'

const state = {
  rewards: [],
  rewardInfo: null,
  reward: null,
  userPoints: [],
  totalPoints: null,
  userPointGroups: []
}

const actions = {
  fetchRewards: async ({commit}, params) => {
    commit('SET_REWARDS', [])
    commit('SET_REWARD_INFO', null)
    const url = 'rewards'
    // let {data} = await axios.get(url, { params: { required_delivery_info: 1 } })
    let {data} = await axios.get(url, { params })
    if (!data.error) {
      commit('SET_REWARDS', data.rewards)
    }
    if (data.total_points || data.user_point_groups) {
      commit('SET_USER_POINTS_DATA', data)
    }
    if (data.reward_information) {
      commit('SET_REWARD_INFO', data.reward_information)
    }
  },
  fetchRewardDetail: async ({commit}, id) => {
    commit('SET_REWARD', null)
    const url = `rewards/${id}`
    let {data} = await axios.get(url)
    if (!data.error) {
      commit('SET_REWARD', data.reward)
    }
  },
  fetchUserPoints: async ({commit}, params) => {
    commit('SET_USER_POINTS', [])
    const url = 'user-points'
    let {data} = await axios.get(url, { params })
    if (!data.error) {
      commit('SET_USER_POINTS', data.user_points)
    }
  }
}

const mutations = {
  SET_REWARDS: (state, rewards) => {
    state.rewards = rewards
  },
  SET_REWARD_INFO: (state, data) => {
    state.rewardInfo = data
  },
  SET_REWARD: (state, reward) => {
    state.reward = reward
  },
  SET_USER_POINTS: (state, userPoints) => {
    state.userPoints = userPoints
  },
  SET_USER_POINTS_DATA: (state, data) => {
    state.totalPoints = data.total_points
    state.userPointGroups = data.user_point_groups
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reward.js